import { proveedorTipoApi } from '../../utils/api';
import { getListDataAction } from '../../utils/DataAction';

export const getAll = getListDataAction({
  dataName: 'PROVEEDOR_TIPO',
  api: proveedorTipoApi,
  relUrl: '',
});
